const InitialValues = {
  app: {
    cartItems: [],
    addresses: [],
    isReady: false,
    isSiteActive: true,
    cities: [],
    areas: [],
    payments: [],
    banners: [],
    openingHours: [],
  },
};

export default InitialValues;
